export const ONINPUT_FOCUS = 'ONINPUT_FOCUS'
export const ONINPUT_BLUR = 'ONINPUT_BLUR'
export const TEXT_CHANGE = 'TEXT_CHANGE'
export const CLOSE_DIALOG = 'CLOSE_DIALOG'
export const ERROR = 'ERROR'
export const HANDLE_RESET = 'HANDLE_RESET'
export const RESET_SUCCESS = 'RESET_SUCCESS'
export const RESET_FAILED = 'RESET_FAILED'
export const PASS_FAILED = 'PASS_FAILED'
import { getTranslate, getActiveLanguage } from 'react-localize-redux'
import api from '../../../api'
import { serverUrl, apiUrl } from '../../../../config/react'
import {browserHistory} from 'react-router'

export function handleReset(){
  return (dispatch, getState) => {
  var newPass = getState().resetPass.newPass;
  var rePass = getState().resetPass.rePass;
  let locale = {...getState().locale};
  let translate = getTranslate(locale);
    if(newPass == rePass){
      var body = {
          "doctor": {
              "password": getState().resetPass.newPass
          }
      }
      var data = JSON.stringify(body);
      var token = getState().location.query.access_token;
      return new Promise((resolve, reject) => {
        function reqListener(){
          if(this.response && !(this.response.indexOf('Error') > -1)){
            var response = this.response;
            dispatch({
              type: RESET_SUCCESS,
              payload: true,
              message: translate('Your_password_changed')
            })
          }else{
            dispatch({
              type: RESET_FAILED,
              payload: true,
              message: translate('Password_reset_failed')
            })
          }
        }
        var oReq = new XMLHttpRequest();
        oReq.addEventListener("load", reqListener);
        oReq.open("PUT", serverUrl + apiUrl + "/doctors/password");
        oReq.setRequestHeader("authorization", "Basic " + token);
        oReq.setRequestHeader("Content-Type", "application/json");
        oReq.send(data);
      })
    }else{
      dispatch({
        type: PASS_FAILED,
        payload: true,
        message: translate('Passwords_not_Match')
      })
    }
  }
}

export function resetDialog(){
  return (dispatch, getState) => {
    var token = getState().location.query.access_token;
    let locale = {...getState().locale};
    let translate = getTranslate(locale);
    if(token){
      return new Promise((resolve, reject) => {
        function reqListener(){
          if(this.response && !(this.response.indexOf('Error') > -1)){
            var response = this.response;
            // localStorage.setItem('doctor', JSON.stringify(response.doctor));
          }else{
            dispatch({
              type: ERROR,
              payload: true,
              message: translate('Token_expired')
            })
          }
        }
        var oReq = new XMLHttpRequest();
        oReq.addEventListener("load", reqListener);
        oReq.open("GET", serverUrl + apiUrl + "/doctors/detail");
        oReq.setRequestHeader("authorization", "Basic " + token);
        oReq.setRequestHeader("media-type", "application/json");
        oReq.send();
        })
    }else{
      dispatch({
        type: ERROR,
        payload: true,
        message: translate('Token_expired')
      })
    }
  }
}

export function closeDialog(){
  return {
    type: CLOSE_DIALOG,
    payload: false
  }
}

export function textChange(key, text){
  return {
    type : TEXT_CHANGE,
    payload : text,
    key
  }
}

export function handleFocus(key){
    return {
        type    : ONINPUT_FOCUS,
        payload : 'input-focus',
        key
      }
}

export function handleBlur(){
    return {
        type    : ONINPUT_BLUR,
        payload : ""
      }
}

  
  const ACTION_HANDLERS = {
    [ONINPUT_FOCUS] : (state, action) => {
      return Object.assign({}, state, {
        focusEmail: "",
        focusPass: "",
        [action.key]: action.payload
      })
    },
    [ONINPUT_BLUR] : (state, action) => {
      return Object.assign({}, state, {
        focusEmail: action.payload,
        focusPass: action.payload
      })
    },
    [TEXT_CHANGE]: (state, action) => {
      return Object.assign({}, state, {
        [action.key]: action.payload
      })
    },
    [CLOSE_DIALOG] : (state, action) => {
      return Object.assign({}, state, {
        dialog: action.payload
      })
    },
    [ERROR] : (state, action) => {
      return Object.assign({}, state, {
        dialog: action.payload,
        message: action.message
      })
    },
    [HANDLE_RESET] : (state, action) => {
      return Object.assign({}, state, {
        dialog: action.payload,
        message: action.message
      })
    },
    [RESET_SUCCESS] : (state, action) => {
      return Object.assign({}, state, {
        dialog: action.payload,
        message: action.message
      })
    },
    [RESET_FAILED] : (state, action) => {
      return Object.assign({}, state, {
        dialog: action.payload,
        message: action.message
      })
    },
    [PASS_FAILED] : (state, action) => {
      return Object.assign({}, state, {
        dialog: action.payload,
        message: action.message
      })
    }
  }
  
   const initialState = {
      focusEmail: "",
      focusPass:"",
      newPass:"",
      rePass:"",
      message: "",
      dialog:false
  };
  export default function counterReducer (state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type]
  
    return handler ? handler(state, action) : state
  }
  


// WEBPACK FOOTER //
// ./src/routes/ResetPassword/modules/resetPassword.js